var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContainerDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_36)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126.5,
    height: 126.5,
    rx: 63.25,
    fill: "#896CAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9 82.1H34.3V52.4C33.2 53.5 31.7 54.5 29.9 55.6C28.1 56.7 26.5 57.5 25 58V53.5C27.6 52.3 29.9 50.8 31.8 49.1C33.7 47.4 35.1 45.7 35.9 44H38.9V82.1Z",
    fill: "#2F393F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7 63.4C47.7 58.9 48.1999 55.3 49.0999 52.6C49.9999 49.9 51.4 47.8 53.2 46.3C55 44.8 57.2999 44.1 60.0999 44.1C62.0999 44.1 63.8999 44.5 65.3999 45.3C66.8999 46.1 68.2 47.3 69.2 48.8C70.2 50.3 71 52.2 71.6 54.4C72.2 56.6 72.4999 59.6 72.4999 63.4C72.4999 67.8 72 71.4 71.1 74.2C70.2 76.9 68.7999 79 66.9999 80.5C65.1999 82 62.8999 82.7 60.0999 82.7C56.3999 82.7 53.6 81.4 51.5 78.8C49 75.6 47.7 70.5 47.7 63.4ZM52.5 63.4C52.5 69.6 53.2 73.8 54.7 75.8C56.2 77.9 57.9999 78.9 60.0999 78.9C62.1999 78.9 63.9999 77.9 65.4999 75.8C66.9999 73.7 67.7 69.6 67.7 63.4C67.7 57.2 66.9999 53 65.4999 51C63.9999 48.9 62.1999 47.9 60.0999 47.9C57.9999 47.9 56.3 48.8 55 50.6C53.3 52.9 52.5 57.2 52.5 63.4Z",
    fill: "#2F393F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4 72L102 72.6C101.5 75.8 100.2 78.2 98.2 80C96.1 81.8 93.6 82.7 90.6 82.7C86.8 82.7 83.8 81.5 81.5 79C79.2 76.5 78.1 73 78.1 68.4C78.1 65.4 78.6 62.8 79.6 60.6C80.6 58.4 82.1 56.7 84.1 55.6C86.1 54.5 88.3 53.9 90.6 53.9C93.6 53.9 96 54.7 97.9 56.2C99.8 57.7 101 59.8 101.5 62.6L97 63.3C96.6 61.5 95.8 60.1 94.7 59.1C93.6 58.2 92.3 57.7 90.7 57.7C88.4 57.7 86.5 58.5 85 60.2C83.5 61.9 82.8 64.5 82.8 68.2C82.8 71.9 83.5 74.6 84.9 76.2C86.3 77.9 88.2 78.7 90.4 78.7C92.2 78.7 93.7 78.1 95 77C96.3 76 97.1 74.3 97.4 72Z",
    fill: "#2F393F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126.5,
    height: 126.5,
    rx: 63.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerDeposit);
export default __webpack_public_path__ + "static/media/container-deposit.df336c51a8600e1e4dd9b47cef595baa.svg";
export { ForwardRef as ReactComponent };